var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeInvisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8C2.80685 3.88734 7.0516 1 12 1C16.9484 1 21.1931 3.88734 23 8C21.1931 12.1127 16.9484 15 12 15C7.0516 15 2.80685 12.1127 1 8Z",
    stroke: "#CDCDCD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 3,
    stroke: "#CDCDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 1L1 15",
    stroke: "#CDCDCD",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeInvisible);
export default __webpack_public_path__ + "static/media/eye-invisible.372e1ad3.svg";
export { ForwardRef as ReactComponent };